import { useEffect, useCallback } from 'react'

type Theme = 'light' | 'dark'

/**
 * Hook for managing dark/light theme preference.
 *
 * TEMPORARILY LOCKED TO LIGHT MODE.
 * Dark mode is disabled while visual updates are in progress.
 * To re-enable: restore the original useState logic and remove the force-light useEffect.
 */
export function useTheme() {
  // Force light mode — remove dark class if it was persisted
  useEffect(() => {
    document.documentElement.classList.remove('dark')
    try {
      localStorage.setItem('creditos-theme', 'light')
    } catch {
      // ignore
    }
  }, [])

  const toggleTheme = useCallback(() => {
    // no-op while dark mode is disabled
  }, [])

  const setTheme = useCallback((_next: Theme) => {
    // no-op while dark mode is disabled
  }, [])

  return {
    theme: 'light' as Theme,
    toggleTheme,
    setTheme,
    isDark: false,
  }
}
